import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-heart, comment, feedback"} maskId="square-filled-radius-0-stroke-1-IconBubbleHeart"><path fillRule="evenodd" clipRule="evenodd" d="M21 3.00002L3 3V19L8.83366 19L11.996 21.6509L15.1957 19H21V3.00002ZM16 10.504C16 13.3735 12 14.9484 12 14.9484C12 14.9484 8 13.3735 8 10.504C8 8.35338 10.1501 7.07303 12 8.2679C13.8499 7.07303 16 8.35338 16 10.504Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubbleHeart;
